import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import TobApplicationBar from "../../../components/Applications/TobApplicationBar";
import Loading from "../../../components/Loading";
import { getSecureApplications } from "../../../redux/actions/application_actions";

const SecureApplications = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchWord, setSearchWord] = useState("");

  const dispatch = useDispatch();

  const token = useSelector(
    (state) => state.auth_reducers.auth_credentials.token,
  );

  useEffect(() => {
    const getApplications = async () => {
      try {
        setLoading(true);
        await dispatch(getSecureApplications(token));

        setLoading(false);
      } catch (err) {
        console.log(err.message);
        setLoading(false);
      }
    };

    getApplications();
  }, [token, dispatch]);

  const secureApplications = useSelector(
    (state) => state.application_reducers.secureApplications,
  );

  useEffect(() => {
    if (secureApplications) {
      setData(secureApplications);
    }
  }, [secureApplications]);

  useEffect(() => {
    if (secureApplications && searchWord && searchWord.length > 0) {
      let tempData = [...secureApplications];
      const word = searchWord.trim().toLowerCase().replace(/\s+/g, " ");

      if (word.length > 0) {
        // eslint-disable-next-line array-callback-return
        tempData = tempData.filter((item) => {
          if (
            item.fullName.trim().toLowerCase().includes(word) ||
            item.carMakeModel.trim().toLowerCase().includes(word) ||
            item.yearOfManufacture.trim().toLowerCase().includes(word)
          ) {
            return true;
          }
        });

        setData(tempData);
      }
    } else {
      setData(secureApplications);
    }
  }, [searchWord, secureApplications]);

  console.log(data)

  return (
    <div className="applications p-3">
      <TobApplicationBar
        title="Secure Applications"
        seachWord={searchWord}
        setSearchWord={setSearchWord}
      />

      {loading ? (
        <Loading />
      ) : (
        <div className="row">
          <div className="col-lg-12">
            <div className="table-responsive position-relative max-height-80">
              <table className="table table-hover">
                <thead>
                  <tr>
                    <th className="bg-dark-white border-right-gray px-3"></th>
                    <th
                      colSpan="2"
                      className="bg-dark-white text-center border-right-gray px-3"
                    >
                      Partner Details
                    </th>
                    <th
                      colSpan="2"
                      className="bg-dark-white text-center border-right-gray px-3"
                    >
                      Vehicle Details
                    </th>
                    <th className="bg-dark-white border-right-gray text-center px-3">
                      Application Status
                    </th>
                    <th className="bg-dark-white border-right-gray text-center px-3">
                      Time of submission
                    </th>
                  </tr>
                  <tr>
                    <th
                      className="bg-dark-white min-width-35 d-flex align-items-center justify-content-center"
                      rowSpan="2"
                    >
                      #
                    </th>
                    <th className="application-top bg-blue ">Name</th>
                    <th className="application-top bg-blue">Mobile No</th>
                    <th className="application-top bg-red">Make & Model</th>
                    <th className="application-top bg-red">
                      Year Of Manufacture
                    </th>
                    <th className="application-top bg-pink">Status</th>
                    <th className="application-top bg-success">Timestamp</th>
                  </tr>
                </thead>
                <tbody>
                  {data && data.length > 0 ? (
                    <>
                      {data &&
                        data.map((application, index) => (
                          <tr key={application._id}>
                            <th className="applications-col col-light-blue min-width-35 text-center">
                              {index + 1}
                            </th>
                            <td className="applications-col col-white">
                              {application.fullName}
                            </td>
                            <td className="applications-col col-white">
                              {application.phoneNumber}
                            </td>
                            <td className="applications-col col-light-blue">
                              {application.carMakeModel}
                            </td>
                            <td className="applications-col col-light-blue">
                              {application.yearOfManufacture}
                            </td>
                            <td className="applications-col col-light-blue text-blue px-5">
                              {application?.status}
                            </td>
                            <td className="applications-col col-white  text-blue">
                              {new Date(application.createdAt).toLocaleString()}
                            </td>
                          </tr>
                        ))}
                    </>
                  ) : (
                    <tr>
                      <td colSpan="11" className="text-center ">
                        <div className="min-height-20 d-flex align-items-center justify-content-center">
                          {" "}
                          No current secure applications
                        </div>
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default SecureApplications;
